import ApiBase from './ApiBase'
import StockItem from '../models/StockItem'
import UserApi from '@/api/UserApi'
import firebase from './firebase'

// use memory only cache instead of local storage cache
const memCachedStocks = {}
let isListCached = false

class StockApi extends ApiBase {
  /**
   * add a stock item to user's stock folder
   * @param {StockItem} st tartget stock item. uid must be loggedin user its self or just blank (automativally assigned if it is blank).
   * @return {Promise<StockItem>} // Same stock item (uid, created are filled automatically)
   */
  addToStocks (st) {
    const uid = UserApi.uid
    const uname = UserApi.uname
    if (st.constructor !== StockItem) {
      return Promise.reject(new Error('invalid argument. expected StockItem, got:', st))
    }
    const stCp = st.clone()
    if (!stCp.uid) {
      stCp.uid = uid
      stCp.uname = uname
    } else if (stCp.uid !== uid) {
      return Promise.reject(new Error('Can not add other users stock at this time'))
    }
    stCp.created = Date.now()
    const db = firebase.firestore()
    const docRef = db.collection('user-stocks').doc(stCp.sid)
    this.addToMemCache(stCp)
    return docRef.set(stCp.toObj()).then(() => stCp)
  }

  /**
   * Remove stock item from user's stocks
   * @param {String} sid stock id to remove.
   * @return {Promise<void>}
   */
  removeFromStocks (sid) {
    if (!sid) {
      return Promise.reject(new Error('invalid argument. sid reuired', sid))
    }
    const db = firebase.firestore()
    this.delFromMemCache(sid)
    return db.collection('user-stocks').doc(sid).delete()
  }

  /**
   * get all stockItems of current user.
   * @return {Promise<Array<StockItem>>} Array<StockItem> will be provided when resolved.
   */
  getStocks () {
    const cachedList = this.getAllMemCached()
    if (cachedList.length && isListCached) { return Promise.resolve(cachedList) }
    const uid = UserApi.uid
    const db = firebase.firestore()
    const query = db.collection('user-stocks').where('uid', '==', uid)
      .orderBy('created', 'desc')
      .get().then((snap) => {
        const recs = []
        snap.forEach(o => recs.push(o.data()))
        return recs.map(rec => {
          const item = new StockItem()
          item.fromObj(rec)
          this.addToMemCache(item)
          isListCached = true
          return item
        })
      }).then(stocks => {
        return stocks
      })
    return query
  }

  getStock (sid) {
    const mcached = this.getMemCached(sid)
    if (mcached) { return Promise.resolve(mcached) }
    const db = firebase.firestore()
    return db.collection('user-stocks').doc(sid).get().then(snap => {
      const data = snap.data()
      const item = new StockItem()
      item.fromObj(data)
      return item
    }).catch(err => {
      console.error(`error while promise getStock: ${sid}`, err)
    })
  }

  addToMemCache (stock) {
    memCachedStocks[stock.sid] = stock
  }
  delFromMemCache (sid) {
    delete memCachedStocks[sid]
  }
  getMemCached (sid) {
    return memCachedStocks[sid] || null
  }
  /**
   * Get all stocks if cached. if not, return 0 length array.
   * @return {Array<StockItem>}
   */
  getAllMemCached () {
    return memCachedStocks ? Object.values(memCachedStocks).sort((a, b) => b.created - a.created) : []
  }
  isInCache (sid) {
    return memCachedStocks && memCachedStocks[sid]
  }
}

export default new StockApi()



// WEBPACK FOOTER //
// ./src/api/StockApi.js